import { apiClient } from './apiClient';

export type EmailMacro = {
  key: string;
  description: string;
};

export type EmailTemplate = {
  id: string;
  name: string;
  kind: string;
  subject: string;
  bodyHtml: string;
  bodyText?: string | null;
  isActive: boolean;
  moduleCodes: string[];
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type EmailTemplateUpsert = {
  name: string;
  kind: string;
  subject: string;
  bodyHtml: string;
  bodyText?: string | null;
  isActive: boolean;
  moduleCodes: string[];
};

const ADMIN_BASE = '/v1/email-templates';
const CS_BASE = '/v1/customer-success/email-templates';

function basePath(scope: 'admin' | 'customer-success'): string {
  return scope === 'admin' ? ADMIN_BASE : CS_BASE;
}

export async function listEmailTemplates(
  scope: 'admin' | 'customer-success' = 'admin',
  moduleCode?: string,
): Promise<EmailTemplate[]> {
  const response = await apiClient.get<EmailTemplate[]>(basePath(scope), {
    params: scope === 'admin' && moduleCode ? { moduleCode } : undefined,
  });
  return response.data;
}

export async function getEmailTemplate(
  id: string,
  scope: 'admin' | 'customer-success' = 'admin',
): Promise<EmailTemplate> {
  const response = await apiClient.get<EmailTemplate>(`${basePath(scope)}/${id}`);
  return response.data;
}

export async function listEmailMacros(
  scope: 'admin' | 'customer-success' = 'admin',
): Promise<EmailMacro[]> {
  const response = await apiClient.get<EmailMacro[]>(`${basePath(scope)}/macros`);
  return response.data;
}

export async function createEmailTemplate(
  payload: EmailTemplateUpsert,
  scope: 'admin' | 'customer-success' = 'admin',
): Promise<EmailTemplate> {
  const response = await apiClient.post<EmailTemplate>(basePath(scope), payload);
  return response.data;
}

export async function updateEmailTemplate(
  id: string,
  payload: EmailTemplateUpsert,
  scope: 'admin' | 'customer-success' = 'admin',
): Promise<EmailTemplate> {
  const response = await apiClient.put<EmailTemplate>(`${basePath(scope)}/${id}`, payload);
  return response.data;
}

export async function deleteEmailTemplate(
  id: string,
  scope: 'admin' | 'customer-success' = 'admin',
): Promise<void> {
  await apiClient.delete(`${basePath(scope)}/${id}`);
}
